import React, { Component } from "react";
import LayoutBackoffice from "../../header_footer/LayoutBackoffice";

import axios from "axios";

import { FormattedDate } from "react-intl";

import {deleteDataonServer, pushDatatoServer} from '../../../../components/utils/RequestsHelper';

import Modal from 'react-modal';

import PropTypes from "prop-types";

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
    }
  };

class Inscricao extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
      };

  constructor(props) {
    super(props);

    this.state = {
      inscricao: {},
      isModalOpen: false
    };

    this.loadInscricao = this.loadInscricao.bind(this);
    this.openModal = this.openModal.bind(this); 
    this.closeModal = this.closeModal.bind(this);
    this.confirmarPagamento = this.confirmarPagamento.bind(this);
    
  }

  componentDidMount() {
    this.loadInscricao();
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  loadInscricao = async () => {
    let id = this.props.match.params.inscricao;

    let res = {};

    try {
      res = await axios.get("/api/inscricoes/" + id, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let inscricao = res.data.inscricao;
    console.log(inscricao);
    this.setState({ inscricao });
  };

  confirmarPagamento = async () => {
    //enviar pedido backoffice para confirmar o pagamento da reserva
    let res = {};
    let data = {};

    try{
      res = await pushDatatoServer(
        "/api/inscricoes/" + this.state.inscricao._id,
        data,
        "put"
      );
      if (
        res.data.errors !== undefined &&
        res.data.errors.length !== 0
      ) {
        alert("deu erro no backend");
      } else {
        this.setState({inscricao: res.data});
      }
    } catch (err) {
      console.log(res);
    }



  };

  deleteButtonClicked = () => {
    
    let promiseObj = deleteDataonServer('/api/inscricoes/' + this.state.inscricao._id);
    promiseObj.then(response => {
        if (response !== undefined){
          this.context.router.history.push("/backoffice/eventos/"+this.props.match.params.identifier);
        }
    })
    .catch(err => {
        this.context.router.history.push("/backoffice/eventos/"+this.props.match.params.identifier);
    });

  };

  render() {
    return (
      <LayoutBackoffice>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Delete Modal"
        >
          <h4>Deseja apagar a reserva?</h4>

          <p>Se apagar a reserva, não poderá voltar atrás. Certifique-se da data em que a pessoa se inscreveu, para verificar que já pode ser apagada/cancelada.</p>

          <div className="">
            <button
              onClick={this.deleteButtonClicked}
              className="backoffice-btn btn btn-outline-success"
            >
              Sim, apagar.
            </button>

            <button
              className="backoffice-btn btn btn-outline-danger"
              onClick={this.closeModal}
            >
              Fechar
            </button>
          </div>
        </Modal>

        <div className="container backoffice-details">
          <div className="div-btn">
            {this.state.inscricao.estaPago === false && 
              <button
                type="button"
                className="backoffice-btn btn btn-outline-info"
                onClick={this.confirmarPagamento}
              >
                Confirmar Pagamento
              </button>
            }
              <button
                type="button"
                className="backoffice-btn btn btn-outline-danger"
                onClick={this.openModal}
              >
                Apagar reserva
              </button>
            {this.state.inscricao.estaPago === true &&
              <button
                type="button"
                className="backoffice-btn btn btn-outline-info"
                onClick={this.confirmarPagamento}
              >
                Cancelar Pagamento
              </button>
            }
          </div>

          <p className="labels">Nome da Reserva</p>
          <p className="details">{this.state.inscricao.name}</p>

          <p className="labels">Email da Reserva</p>
          <p className="details">{this.state.inscricao.email}</p>

        <div className="row">
            <div className="col-4">
                <p className="labels">Telefone da Reserva</p>
                <p className="details">{this.state.inscricao.telefone}</p>
            </div>

            {this.state.inscricao.numeroAdultos 
            ?
            <React.Fragment>
              <div className="col-4">
                  <p className="labels">Número de Adultos</p>
                  <p className="details">{this.state.inscricao.numeroAdultos}</p>
              </div>
              <div className="col-4">
                  <p className="labels">Número de Crianças</p>
                  <p className="details">{this.state.inscricao.numeroCriancas}</p>
              </div>
            </React.Fragment>
            
            :
              <div className="col-4">
                <p className="labels">Número de Pessoas</p>
                <p className="details">{this.state.inscricao.numeroPessoas}</p>
              </div>
            }
            
            <div className="col-4">
                <p className="labels">Data da Reserva</p>
                <p className="details">
                    <FormattedDate
                    value={new Date(this.state.inscricao.enrollmentDate)}
                    year="numeric"
                    month="long"
                    day="2-digit"
                    />
                </p>
            </div>
        </div>

          <p className="labels">Está pago?</p>
          <p className="details">{this.state.inscricao.estaPago ? "Sim" : "Não"}</p>

        </div>
      </LayoutBackoffice>
    );
  }
}

export default Inscricao;
